export { default } from "./HomeXrayCard";
